import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "src/components/BootstrapTable";
import DetailButton from "src/components/DetailButton";
import Title from "src/components/Title";
import TableFormatter from "src/utils/tableFormatter";

const SwipeCheckOverviewSite = () => {
  const navigate = useNavigate();
  const table = useRef();

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Swipe-Überprüfung</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            url="/api/backend/swipes/review"
            sort="review_submit_at"
            order="asc"
            ref={table}
            showSearch
            showClear
            showRefresh
            showFilter
            cache
            pageSize={25}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "name",
                name: "Name",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "street",
                name: "Strasse",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "street_no",
                name: "Nr",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "postcode",
                name: "PLZ",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "city",
                name: "Stadt",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "review_submit_at",
                name: "Eingereicht am",
                sortable: true,
                formatter: TableFormatter.formatDateTime,
              },
              {
                field: "id",
                textAlign: "right",
                width: 120,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <DetailButton url={`/swipe/check/${value}`} />{" "}
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SwipeCheckOverviewSite;
